import Grid from '@mui/material/Grid';
import crmImg from 'assets/img/crm.svg';
import {rayChatUrl} from 'helpers/Functions';
import makeStyles from '@mui/styles/makeStyles';

const useStyle = makeStyles({
  help: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    width: '196px',
    height: '48px',
    padding: '15px 0 12px 0',
    marginTop: '10px !important ',
    borderRadius: '100px',
    boxShadow:
      '-4px -4px 15px 0 var(--white), 4px 4px 15px 0 rgba(172, 172, 172, 0.5)',
    border: 'solid 1px var(--white)',
    backgroundColor: 'var(--light-gray-1)',
  },
  helpText: {
    fontSize: '14px',
    color: '#4e4e4e',
    border: 'none',
    marginLeft: '5px',
    backgroundColor: 'transparent',
  },
  helperText: {
    fontSize: '14px',
    color: '#753cbe',
  },
});
export default function CrmHelpButton(props) {
  const classes = useStyle();
  return (
    <Grid container>
      {props.text && (
        <Grid
          item
          display='flex'
          justifyContent='center'
          alignItems='center'
          xs={12}
          mb='16px'>
          <p className={classes.helperText}>
            اگر نیاز به کمک دارید، به پشتیبانی پیام دهید:
          </p>
        </Grid>
      )}
      <Grid
        item
        display='flex'
        justifyContent='center'
        alignItems='center'
        xs={12}>
        <a href={rayChatUrl} target='_blank' rel='noreferrer'>
          <Grid item className={classes.help}>
            <img src={crmImg} alt='' style={{margiLeft: '30px'}} />
            <button className={classes.helpText}>ارسال پیام به پشتیبانی</button>
          </Grid>
        </a>
      </Grid>
    </Grid>
  );
}
